import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/modal.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/modal.js'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dimmer.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dimmer.js'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.js'

import parse from 'react-html-parser'

export class Candidate extends Component {
  componentDidMount() {
    this.handleShowModal = this.handleShowModal.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)

    this.isMobile = window.innerWidth <= 599
  }

  handleShowModal(name, vote) {
    $(`.modal.${name}.${vote}`).modal('show')
  }

  handleModalClose(name) {
    $(`.modal.${name}`).modal('hide')
  }

  render() {
    console.log(this.props.candidate.displayName)
    return (
      <div className='candidate'>
        <div className='ui medium image'>
          <img src={require(`images/${this.props.candidate.name}.jpg`)} />
        </div>
        <div className='content'>
          <div className='description'>
            <div className='header' style={{ 'margin-top': 10 + 'px' }}>
              {this.props.candidate.displayName} ({this.props.candidate.party})
            </div>
          </div>
          <div className='extra content'>
            <div className='ui two buttons' style={{ 'margin-top': 10 + 'px' }}>
              <div
                className='ui button'
                onClick={() =>
                  this.handleShowModal(this.props.candidate.name, 'upvote')
                }
              >
                Wählen
              </div>
              <div
                className='ui secondary button'
                onClick={() =>
                  this.handleShowModal(this.props.candidate.name, 'downvote')
                }
              >
                Verhindern
              </div>
            </div>
          </div>
          <div className={`ui modal ${this.props.candidate.name} upvote`}>
            <div className='header'>
              {this.props.candidate.displayName} wählen
            </div>
            <div className='image content'>
              <img
                className='ui small image'
                style={{ 'max-height': 180 + 'px' }}
                src={require(`images/${this.props.candidate.name}.jpg`)}
              />
              <div className='description'>
                <p>{parse(this.props.candidate.upvote)}</p>
              </div>
            </div>
            <div className='actions'>
              <div
                className='ui primary button'
                onClick={() => this.handleModalClose(this.props.candidate.name)}
              >
                Schliessen
              </div>
            </div>
          </div>
          <div className={`ui modal ${this.props.candidate.name} downvote`}>
            <div className='header'>
              {this.props.candidate.displayName} verhindern
            </div>
            <div className='image content'>
              <img
                className='ui small image'
                style={{ 'max-height': 180 + 'px' }}
                src={require(`images/${this.props.candidate.name}.jpg`)}
              />
              <div className='description'>
                <p>{parse(this.props.candidate.downvote)}</p>
                <p />
              </div>
            </div>
            <div className='actions'>
              <div
                className='ui primary button'
                onClick={() => this.handleModalClose(this.props.candidate.name)}
              >
                Schliessen
              </div>
            </div>
          </div>
          <div className='ui divider' />
        </div>
      </div>
    )
  }
}
